module.exports = __webpack_public_path__ + "static/img/sample_03.037fec2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sample_03.jpg
// module id = O/s3
// module chunks = 1